import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom-v5-compat";

import Footer, { useFooterErrors } from "components/projects/Footer";
import useIsDirectApply from "components/projects/useIsDirectApply";
import { useAnswerContext } from "contexts/answerContext";
import { useOnNext } from "hooks/useOnNext";
import { getAnswer, getRequirementSections } from "queries/projects";
import { getFieldIdentsForPages } from "reducers/answerContexts";
import routes from "utils/routes";
import { getIsProhibited } from "utils/zoning";

const useValidationFieldsForRequirement = (project, requirement) => {
  const sections = getRequirementSections(project, requirement.key);
  const fields = getFieldIdentsForPages(sections);

  return {
    fieldIdents: fields,
  };
};

const RequirementFooter = ({ ...props }) => {
  const navigate = useNavigate();
  const answerContext = useAnswerContext();
  const { record: project = {}, context: requirement = {} } = answerContext;
  const { requirementOrDirect } = useIsDirectApply();
  const { fieldIdents } = useValidationFieldsForRequirement(project, requirement);

  const onNext = useOnNext({
    nextPage: `/projects/${project.id}/${requirementOrDirect}/${requirement.slug}/submit`,
    nextPageType: "PATH",
  });

  const onBack = useCallback(() => {
    navigate(routes.projectHandoff(project.id));
  }, [navigate, project.id]);

  const disableNext = getIsProhibited(getAnswer(project, "zoning")) || answerContext.readOnly;
  const errorsProps = useFooterErrors(fieldIdents);

  return (
    <Footer {...props} {...errorsProps} onNext={onNext} onBack={onBack} disableNext={disableNext} />
  );
};
export default RequirementFooter;
